/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetInvOutReportDetailsQuery } from '../../models/get-inv-out-report-details-query';
import { GetInvOutReportDetailsQueryResult } from '../../models/get-inv-out-report-details-query-result';

export interface ApiNurseryManagerReportsGetInvOutDetailsReportPost$Params {
      body?: GetInvOutReportDetailsQuery
}

export function apiNurseryManagerReportsGetInvOutDetailsReportPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerReportsGetInvOutDetailsReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInvOutReportDetailsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerReportsGetInvOutDetailsReportPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetInvOutReportDetailsQueryResult>;
    })
  );
}

apiNurseryManagerReportsGetInvOutDetailsReportPost.PATH = '/api/NurseryManager/Reports/GetInvOutDetailsReport';
